module.exports = __webpack_public_path__ + "img/ranbeer.f17005c1.jpg";